import React from 'react';
import Grid from '@material-ui/core/Grid';

const SarasGridItem = (props) => {
    return(
        <Grid item xs={props.xs || 12} sm={props.sm || 12} md={props.md || 6}>
            {props.children}
        </Grid>
    )
}

export default SarasGridItem